<template>
  <div>
    <!-- tooltip 结构与下完全一致 多outside -->
    <div
      v-if="isInsetEl"
      v-click-outside="() => $emit('handleCancel')"
      class="modal-inline-wrapper"
      @click.stop="$emit('mask')"
    >
      <div :class="['modal-inline-content', option.position]">
        <div class="content-title">
          <img :src="iconByType" alt="提示" class="w-5 mr-2" />
          <div>{{ option.title }}</div>
        </div>
        <div class="content-text">{{ option.descript }}</div>
        <div class="operate-button">
          <button
            v-show="option.showCancel"
            class="button cancel-button"
            @click.stop="$emit('handleCancel')"
          >
            {{ option.cancelText }}
          </button>
          <button class="button confirm-button" @click.stop="$emit('handleSubmit')">
            {{ option.confirmText }}
          </button>
        </div>
      </div>
    </div>
    <!-- 常规 居中model -->
    <div v-else class="modal-wrapper" @click.stop="$emit('mask')">
      <div class="modal-content">
        <div class="content-title">
          <img :src="iconByType" alt="提示" class="w-5 mr-2" />
          <div>{{ option.title }}</div>
        </div>
        <div class="content-text">{{ option.descript }}</div>
        <div class="operate-button">
          <button
            v-show="option.showCancel"
            class="button cancel-button"
            @click.stop="$emit('handleCancel')"
          >
            {{ option.cancelText }}
          </button>
          <button class="button confirm-button" @click.stop="$emit('handleSubmit')">
            {{ option.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ModalOption } from './confirm';
import clickOutside from 'vue-click-outside';

@Component({
  directives: {
    clickOutside
  }
})
export default class PcView extends Vue {
  @Prop({ type: Object }) option: ModalOption;
  @Prop({ type: String }) iconByType: ModalOption;
  @Prop({ type: Boolean }) isInsetEl: boolean;
}
</script>

<style scoped>
.modal-inline-wrapper {
  /* @apply absolute left-0 top-0; */
}
.modal-wrapper {
  @apply fixed top-0 left-0 w-screen h-screen z-40;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
/* pc */
.modal-content {
  @apply absolute top-1/2 left-1/2 bg-white p-5;
  width: 292px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  transform: translate(-50%, -50%);
}
.modal-inline-content {
  @apply absolute top-0 left-0 bg-white p-5;
  width: 292px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  transform: translate(-105%, 2%);
}

.modal-inline-content.top {
  @apply -top-20;
}
.modal-inline-content::before {
  @apply absolute top-4 right-0;
  width: 8px;
  height: 8px;
  background: #fff;
  border-bottom-right-radius: 4px;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.1);
  transform: translate(50%, -50%) rotate(-45deg);
  content: '';
}
.modal-inline-content.top::before {
  @apply bottom-4 top-auto;
}

.content-title {
  @apply flex items-center font-medium;
  color: #3f3356;
  font-size: 16px;
}

.content-text {
  @apply my-4;
  color: rgba(63, 51, 86, 0.6);
  font-size: 14px;
}

/* button */
.operate-button {
  @apply flex justify-end;
}
.button {
  @apply py-1 px-2 tracking-widest;
  width: 78px;
  height: 34px;
  font-size: 14px;
  border-radius: 6px;
  outline: none !important;
}
.button:hover {
  @apply opacity-80;
}
.cancel-button {
  @apply mr-4 text-motif-500;
  border: 1px solid rgba(110, 87, 236, 0.2);
}
.cancel-button::before {
  content: '';
}
.confirm-button {
  @apply text-white border;
  background: #ef5d5d;
}
.disabled {
  opacity: 0.6;
}
</style>
